import { Request, RequestConfig } from "@cttq/cttq-request";
import axios from "axios";

// 取消请求
const CancelToken = axios.CancelToken
let axiosCancel: any = null //定义存放取消的请求方法

const getHeaders = () => {
	let tenantId = window.localStorage.getItem("saas-pd-tenantId")
	let headers:Record<string, string> = {}
	if(tenantId){
		headers["tenant-id"] = tenantId;
	}
	return headers
}


const axiosInstance = new Request({
	baseURL: import.meta.env.VITE_USER_SAAS_URL,
	cancelRequest: true,
	requestInterceptors: (config: RequestConfig) => {
		// 设置请求头
		config.headers = getHeaders()
		if (config.url.includes("queryPersonList")|| config.url.includes("selOrganizationDepartList")) {
			//模糊查询的时候避免输入太快，直接取最后一次请求返回的结果
			if (typeof axiosCancel === "function") {
					//在请求发出前取消上一次未完成的请求
					axiosCancel("终止请求") //取消请求
			}
			config.cancelToken = new CancelToken(function executor(c: any) {
					axiosCancel = c
			})
		}
		// 请求拦截器
		return config
	},
});
export default axiosInstance;

